export const topics = [
  {
    id: "topic-night-shift",
    title: "夜班时刻",
    subtitle: "为什么深夜的医院，最适合讲故事",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dim%20hospital%20corridor%20at%20night%20with%20rows%20of%20ceiling%20lights%2C%20deep%20blue%20tones%2C%20atmospheric%20fog%2C%20strong%20depth%2C%20no%20text%2C%20photographic&width=1600&height=900&seq=nightward-topic-01&orientation=landscape",
    intro:
      "深夜的医院是一个特殊的时间切片：人手最少、灯最暗、规则最容易被忽略，而人却最真实。本专题从叙事结构、镜头语言与声音设计三个角度，拆解『夜班』这一时段的独特魅力。",
    updatedAt: "2024-09-18",
    tags: ["夜班", "叙事", "镜头语言"],
    sections: [
      {
        title: "一小时一集：实时叙事的张力",
        description: "用接近真实时间的节奏讲述一个夜班，让观众的体感与角色同步。",
        filmIds: ["midnight-er", "night-nurse"]
      },
      {
        title: "灯与影：夜班场景的视觉语法",
        description: "从长走廊的灭点构图到单一光源下的表演，夜班题材建立了一套专属的视觉体系。",
        filmIds: ["night-ward-2023", "silent-corridor", "night-ward-s2"]
      }
    ],
    relatedTopicIds: ["topic-truth", "topic-space"]
  },
  {
    id: "topic-truth",
    title: "被掩埋的真相",
    subtitle: "当一桩旧事故重新被人翻开",
    cover: "https://readdy.ai/api/search-image?query=old%20medical%20archives%20and%20files%20stacked%20on%20a%20desk%20under%20a%20single%20desk%20lamp%20in%20a%20dark%20room%2C%20moody%20cinematic%20tones%2C%20blue%20shadow%2C%20no%20text%2C%20photographic&width=1600&height=900&seq=nightward-topic-02&orientation=landscape",
    intro:
      "几乎每一部夜勤题材作品，最终都会指向同一件事：一段不愿被提起的往事。本专题汇集了以『追查旧案』为核心的代表作，看看创作者如何把档案、录音带与证词变成叙事引擎。",
    updatedAt: "2024-09-12",
    tags: ["真相", "旧案", "调查"],
    sections: [
      {
        title: "档案里的证词",
        description: "从病历、录音带到监控录像，物证如何一步步逼近真相。",
        filmIds: ["night-ward-2023", "night-ward-echoes", "white-night-ward"]
      },
      {
        title: "沉默的共谋",
        description: "当真相被整个体系回避，个体的坚持意味着什么。",
        filmIds: ["glass-ward", "shadowless-lamp", "night-nurse"]
      }
    ],
    relatedTopicIds: ["topic-night-shift", "topic-space"]
  },
  {
    id: "topic-space",
    title: "密闭空间",
    subtitle: "手术室、病房与那条走不出去的走廊",
    cover: "https://readdy.ai/api/search-image?query=interior%20of%20a%20sterile%20operating%20room%20lit%20by%20a%20surgical%20lamp%2C%20deep%20teal%20and%20blue%20shadows%2C%20cinematic%20thriller%20atmosphere%2C%20no%20text%2C%20photographic&width=1600&height=900&seq=nightward-topic-03&orientation=landscape",
    intro:
      "把人物关进一间屋子，紧张感就自动生成了一半。本专题聚焦夜勤题材中对『封闭空间』的运用，从一台手术到一条走廊，看看空间本身如何成为角色。",
    updatedAt: "2024-08-30",
    tags: ["密闭空间", "手术室", "走廊"],
    sections: [
      {
        title: "手术台前的倒计时",
        description: "维持生命与应对外部威胁，两难处境在同一空间里层层叠加。",
        filmIds: ["surgery-3am", "shadowless-lamp"]
      },
      {
        title: "走不出去的走廊",
        description: "走廊是连接空间的通道，也是最容易制造悬念的舞台。",
        filmIds: ["silent-corridor", "ward-seven", "night-ward-s2"]
      }
    ],
    relatedTopicIds: ["topic-night-shift", "topic-truth"]
  },
  {
    id: "topic-new-wave",
    title: "夜勤新浪潮",
    subtitle: "近三年最值得关注的新作与创作者",
    cover: "https://readdy.ai/api/search-image?query=collection%20of%20minimal%20dark%20film%20posters%20arranged%20in%20a%20grid%20on%20a%20concrete%20wall%2C%20cold%20blue%20grey%20tones%2C%20editorial%20gallery%20atmosphere%2C%20no%20text%2C%20photographic&width=1600&height=900&seq=nightward-topic-04&orientation=landscape",
    intro:
      "从日式悬疑到韩国犯罪、再到美式密闭惊悚，夜勤题材在过去三年出现了明显的类型融合趋势。本专题盘点了推动这一浪潮的代表作品与新锐创作者。",
    updatedAt: "2024-08-15",
    tags: ["新作", "趋势", "创作者"],
    sections: [
      {
        title: "口碑黑马",
        description: "上映时并不起眼，却靠细节与气质被观众重新发现的几部作品。",
        filmIds: ["ward-seven", "midnight-rounds", "white-night-ward"]
      },
      {
        title: "类型融合",
        description: "当医疗遇上惊悚、犯罪与实时叙事，边界正在被重新划定。",
        filmIds: ["surgery-3am", "midnight-er", "night-ward-s2"]
      }
    ],
    relatedTopicIds: ["topic-night-shift", "topic-space"]
  }
];

export const heroSlides = [
  {
    id: "hero-01",
    topicId: "topic-night-shift",
    filmId: "night-ward-s2",
    kicker: "本期焦点专题",
    title: "夜班时刻：为什么深夜的医院最适合讲故事",
    description: "从实时叙事到单一光源下的表演，我们拆解夜勤题材独有的视觉与叙事语法。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20ultra%20wide%20shot%20of%20a%20dark%20hospital%20corridor%20at%20night%2C%20rows%20of%20ceiling%20lights%20receding%20into%20distance%2C%20deep%20blue%20and%20teal%20tones%2C%20atmospheric%20fog%2C%20dramatic%20mood%2C%20no%20text&width=1920&height=800&seq=nightward-hero-01&orientation=landscape",
    tag: "专题"
  },
  {
    id: "hero-02",
    topicId: "topic-space",
    filmId: "surgery-3am",
    kicker: "新作首发",
    title: "凌晨三点的手术：密闭空间里的120分钟倒计时",
    description: "手术室被反锁，通讯被切断，门外只留下一个条件——这台手术必须失败。",
    image: "https://readdy.ai/api/search-image?query=dramatic%20ultra%20wide%20cinematic%20view%20of%20a%20surgical%20lamp%20glowing%20in%20a%20dark%20operating%20room%2C%20deep%20teal%20shadows%2C%20tense%20thriller%20mood%2C%20sterile%20instruments%20in%20foreground%2C%20no%20text&width=1920&height=800&seq=nightward-hero-02&orientation=landscape",
    tag: "新作"
  },
  {
    id: "hero-03",
    topicId: "topic-truth",
    filmId: "night-ward-echoes",
    kicker: "续作定档",
    title: "暗夜回响：一盘录音带，重新打开二十年前的现场",
    description: "导演黑泽凉介回归，把叙事重心从『发生了什么』转向『谁在阻止真相被听见』。",
    image: "https://readdy.ai/api/search-image?query=moody%20ultra%20wide%20cinematic%20shot%20of%20an%20old%20hospital%20ward%20at%20night%20with%20moonlight%20through%20blinds%2C%20deep%20blue%20grey%20tones%2C%20mysterious%20atmosphere%2C%20empty%20bed%2C%20no%20text&width=1920&height=800&seq=nightward-hero-03&orientation=landscape",
    tag: "专题"
  }
];